import icProgramArt from "@/assets/images/user/icProgramArt.svg";
// import programArtCont1Img1 from "@/assets/images/user/programArtCont1Img1.jpg";
// import programArtCont1Img2 from "@/assets/images/user/programArtCont1Img2.jpg";
import programArt2026Cont1Img1 from "@/assets/images/user/programArt2026Cont1Img1.jpg";
import programArt2026Cont2Img1 from "@/assets/images/user/programArt2026Cont2Img1.jpg";
import programArt2026Cont3Img1 from "@/assets/images/user/programArt2026Cont3Img1.jpg";
import ProgramAccordion from "@/components/user/common/ProgramAccordion";

const txtBoxClass =
    "max-w-[72px] w-full text-[16px] py-[4px] text-[#000] font-['GongGothicMedium'] text-center leading-[25px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[120px] md:text-[20px] md:py-[10px]";

const programList = [
    {
        title: (
            <p className="flex">
                GXG 코스튬 갤러리｜
                <br className="sm:hidden" />
                스마일게이트 X RZCOS
            </p>
        ),
        background: "bg-program202503",
        img: icProgramArt,
        contents: (
            <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-[24px]">
                <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>일시</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            9.11 (금) ~ 9.12 (토) 13:00 ~ 21:00
                        </p>
                    </li>
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>장소</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            판교역 중앙광장
                        </p>
                    </li>
                    <li className="flex items-start gap-[8px] md:items-center md:gap-[20px]">
                        <p className={txtBoxClass}>내용</p>
                        <ul className="flex flex-1 flex-col gap-[4px] font-['GongGothicLight'] text-[16px] leading-[1.6] text-black md:text-[18px]">
                            <li>
                                게임 속 세계관을 현실로 구현한 <br className="block sm:hidden" /> 코스튬 작품과 소품,
                                창작 콘텐츠를 <br className="sm:hidden" />
                                선보이는 전시!
                            </li>
                            <li>
                                게임 캐릭터와 만나는 특별한 세계, <br className="sm:hidden" />
                                로스트아크의 다양한 작품을 <br className="sm:hidden" />
                                만나보세요!
                            </li>
                        </ul>
                    </li>
                </ul>
                {/* 캡션(GXG 코스튬 갤러리)·하단 그라디언트·1px #DDD 테두리가 모두 이미지에 포함된 1.5배수 소스.
                    CSS border 를 주면 2겹이 되므로 주지 않는다. */}
                <div className="w-full sm:w-[calc(50%-10px)] sm:max-w-[420px] xl:w-[420px] xl:shrink-0">
                    <img src={programArt2026Cont1Img1} alt="GXG 코스튬 갤러리" className="w-full" />
                </div>
            </div>
        ),
    },
    {
        title: <p className="flex">GXG 사회공헌 전시</p>,
        background: "bg-program202503",
        img: icProgramArt,
        contents: (
            <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-[24px]">
                <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>일시</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            9.11 (금) ~ 9.12 (토) 13:00 ~ 21:00
                        </p>
                    </li>
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>장소</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            판교 테크원 2층
                        </p>
                    </li>
                    <li className="flex items-start gap-[8px] md:items-center md:gap-[20px]">
                        <p className={txtBoxClass}>내용</p>
                        <ul className="flex flex-1 flex-col font-['GongGothicLight'] text-[16px] leading-[1.6] text-black md:text-[18px]">
                            <li>게임은 화면을 넘어 사회로 이어집니다.</li>
                            <li>
                                게임업계가 교육, 문화, 환경, <br className="block sm:hidden" />
                                지역사회 등 다양한 분야에서 펼쳐온 <br className="block sm:hidden" />
                                사회공헌 활동을 한눈에 만나는 <br className="block sm:hidden" />
                                전시입니다.
                            </li>
                        </ul>
                    </li>
                </ul>
                {/* 캡션(GXG 사회공헌 전시)·하단 그라디언트·1px #DDD 테두리가 모두 이미지에 포함된 1.5배수 소스 */}
                <div className="w-full sm:w-[calc(50%-10px)] sm:max-w-[420px] xl:w-[420px] xl:shrink-0">
                    <img src={programArt2026Cont2Img1} alt="GXG 사회공헌 전시" className="w-full" />
                </div>
            </div>
        ),
    },
    {
        title: <p className="flex">GXG SOUND TRACK 전시</p>,
        background: "bg-program202503",
        img: icProgramArt,
        contents: (
            <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-[24px]">
                <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>일시</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            9.11 (금) ~ 9.12 (토) 13:00 ~ 20:00
                        </p>
                    </li>
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>장소</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            테크원타워 2층
                        </p>
                    </li>
                    <li className="flex items-start gap-[8px] md:items-center md:gap-[20px]">
                        <p className={txtBoxClass}>내용</p>
                        <ul className="flex flex-1 flex-col font-['GongGothicLight'] text-[16px] leading-[1.6] text-black md:text-[18px]">
                            <li>
                                GXG SOUND TRACK의
                                <br className="block sm:hidden" /> 지난 3년을 한자리에서 만나는 음악
                                <br className="block sm:hidden" /> 아카이브 전시입니다. <br />
                                2024년부터 2026년까지 본선 진출
                                <br className="block sm:hidden" />
                                곡과 모티브 게임을 함께 확인하며, <br />
                                게임에서 받은 영감이 음악으로
                                <br className="block sm:hidden" /> 만들어내는 새로운 창작의 매력을
                                <br className="block sm:hidden" /> 경험해 보세요!
                            </li>
                        </ul>
                    </li>
                </ul>
                {/* 역대 GXG SOUND TRACK 포스터 3종 (2배수 이미지, 최대 400px로 렌더) */}
                <div className="flex w-full items-center justify-center md:w-[calc(50%-10px)] xl:h-[280px] xl:w-[420px] xl:shrink-0">
                    <img
                        src={programArt2026Cont3Img1}
                        alt="The 1st·2nd·3rd GXG SOUND TRACK 포스터"
                        className="w-full xl:max-w-[400px]"
                    />
                </div>
            </div>
        ),
    },
];

// ===== 2025 콘텐츠(이미지 포함) - 삭제하지 말고 재사용 대비 보존 =====
// const programList = [
//     {
//         title: "[The Art] GXG 코스튬 갤러리",
//         background: "bg-program202503",
//         img: icProgramArt,
//         contents: (
//             <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-0">
//                 <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
//                     <li className="flex items-center gap-[8px] md:gap-[20px]">
//                         <p className={txtBoxClass}>일시</p>
//                         <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
//                             9/19(금) ~ 9/20(토), 11:00 ~ 21:00
//                         </p>
//                     </li>
//                     <li className="flex items-center gap-[8px] md:gap-[20px]">
//                         <p className={txtBoxClass}>장소</p>
//                         <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
//                             판교 테크원 1F 로비
//                         </p>
//                     </li>
//                     <li className="flex items-start gap-[8px] md:gap-[20px] md:items-center">
//                         <p className={txtBoxClass}>내용</p>
//                         <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
//                             게임, 디자인, 애니메이션, 제품 <br className="md:hidden" />
//                             디자인까지! <br />
//                             4가지 주제로 구성된 게임 그래픽 <br className="md:hidden" />
//                             아트북을 자유롭게 감상하세요.
//                         </p>
//                     </li>
//                 </ul>
//                 {/* <div className="w-full md:w-[calc(50%-10px)] xl:w-1/3">
//                     <img src={programArtCont1Img1} alt="이미지" className="w-full" />
//                 </div> */}
//             </div>
//         ),
//     },
//     {
//         title: "[The Art] GXG SOUND TRACK 전시",
//         background: "bg-program202503",
//         img: icProgramArt,
//         contents: (
//             <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-0">
//                 <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
//                     <li className="flex items-start gap-[8px] md:gap-[20px] md:items-center">
//                         <p className={txtBoxClass}>일시</p>
//                         <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
//                             9/19(금) 13:00~14:00, 20:50~21:30 <br />
//                             9/20(토) 13:00~14:15, 14:15~15:15, 20:50~21:45
//                         </p>
//                     </li>
//                     <li className="flex items-center gap-[8px] md:gap-[20px]">
//                         <p className={txtBoxClass}>장소</p>
//                         <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
//                             북측광장 B - SUB STAGE
//                         </p>
//                     </li>
//                     <li className="flex items-start gap-[8px] md:gap-[20px]">
//                         <p className={txtBoxClass}>내용</p>
//                         <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
//                             유저들의 상상력이 빚어낸 <br className="md:hidden" />
//                             특별한 작품과 함께 영상 속 <br className="md:hidden" />
//                             여행을 떠나볼까요? <br />
//                             상영전 진행되는 선착순 이벤트도 <br className="md:hidden" />
//                             놓치지 마세요.
//                         </p>
//                     </li>
//                     <li className="flex items-start gap-[8px] md:gap-[20px]">
//                         <p className={txtBoxClass}>상영작</p>
//                         <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
//                             9/19(금) <br />
//                             13:00 ~ 14:00 2025 호요페어 &lt;붕괴: 스타레일, 신년 특별 팬아트 프로그램&gt; - 1회
//                             <br />
//                             20:50 ~ 21:30 2025 호요페어 &lt;붕괴: 스타레일, 신년 특별 팬아트 프로그램&gt; - 2회
//                             <br />
//                             <br />
//                             9/20(토) <br />
//                             13:00 ~ 14:15 HoYoFair 기념 &lt;젠레스 존 제로, 2차 창작 특별 프로그램&gt;
//                             <br />
//                             14:15 ~ 15:15 2025 호요페어 &lt;원신, 이세계 탐정의 사건 기록 팬아트 프로그램&gt; - 1회
//                             <br />
//                             20:50 ~ 21:45 2025 호요페어 &lt;원신, 이세계 탐정의 사건 기록 팬아트 프로그램&gt; - 2회
//                             <br />
//                             <br />
//                             ※ 2025 호요페어 &lt;붕괴: 스타레일, 신년 특별 팬아트 프로그램&gt;과 <br />
//                             2025 호요페어 &lt;원신, 이세계 탐정의 사건 기록 팬아트 프로그램&gt;은 각각 1, 2회차로 분할
//                             상영합니다. <br />※ 현장 상황에 따라 시간 및 내용이 변동될 수 있습니다.
//                         </p>
//                     </li>
//                 </ul>
//                 {/* <div className="w-full md:w-[calc(50%-10px)] xl:w-1/3">
//                     <img src={programArtCont1Img2} alt="이미지" className="w-full" />
//                 </div> */}
//             </div>
//         ),
//     },
//     {
//         title: "The Art] GXG 사회공헌 전시",
//         background: "bg-program202503",
//         img: icProgramArt,
//         contents: (
//             <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-0">
//                 <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
//                     <li className="flex items-start gap-[8px] md:gap-[20px] md:items-center">
//                         <p className={txtBoxClass}>일시</p>
//                         <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
//                             9/19(금) 13:00~14:00, 20:50~21:30 <br />
//                             9/20(토) 13:00~14:15, 14:15~15:15, 20:50~21:45
//                         </p>
//                     </li>
//                     <li className="flex items-center gap-[8px] md:gap-[20px]">
//                         <p className={txtBoxClass}>장소</p>
//                         <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
//                             북측광장 B - SUB STAGE
//                         </p>
//                     </li>
//                     <li className="flex items-start gap-[8px] md:gap-[20px]">
//                         <p className={txtBoxClass}>내용</p>
//                         <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
//                             유저들의 상상력이 빚어낸 <br className="md:hidden" />
//                             특별한 작품과 함께 영상 속 <br className="md:hidden" />
//                             여행을 떠나볼까요? <br />
//                             상영전 진행되는 선착순 이벤트도 <br className="md:hidden" />
//                             놓치지 마세요.
//                         </p>
//                     </li>
//                     <li className="flex items-start gap-[8px] md:gap-[20px]">
//                         <p className={txtBoxClass}>상영작</p>
//                         <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
//                             9/19(금) <br />
//                             13:00 ~ 14:00 2025 호요페어 &lt;붕괴: 스타레일, 신년 특별 팬아트 프로그램&gt; - 1회
//                             <br />
//                             20:50 ~ 21:30 2025 호요페어 &lt;붕괴: 스타레일, 신년 특별 팬아트 프로그램&gt; - 2회
//                             <br />
//                             <br />
//                             9/20(토) <br />
//                             13:00 ~ 14:15 HoYoFair 기념 &lt;젠레스 존 제로, 2차 창작 특별 프로그램&gt;
//                             <br />
//                             14:15 ~ 15:15 2025 호요페어 &lt;원신, 이세계 탐정의 사건 기록 팬아트 프로그램&gt; - 1회
//                             <br />
//                             20:50 ~ 21:45 2025 호요페어 &lt;원신, 이세계 탐정의 사건 기록 팬아트 프로그램&gt; - 2회
//                             <br />
//                             <br />
//                             ※ 2025 호요페어 &lt;붕괴: 스타레일, 신년 특별 팬아트 프로그램&gt;과 <br />
//                             2025 호요페어 &lt;원신, 이세계 탐정의 사건 기록 팬아트 프로그램&gt;은 각각 1, 2회차로 분할
//                             상영합니다. <br />※ 현장 상황에 따라 시간 및 내용이 변동될 수 있습니다.
//                         </p>
//                     </li>
//                 </ul>
//             </div>
//         ),
//     },
// ];
// ===== 2025 콘텐츠 보존 끝 =====

export default function Art() {
    return (
        <>
            <div className="p-[48px_0_20px] font-['GongGothicLight'] text-[12px] md:text-[18px] xl:pt-[60px] xl:text-right xl:text-[24px]">
                * 프로그램 구성 및 시간은 현장 상황에 따라 변동될 수 있습니다.
            </div>
            <ProgramAccordion
                list={programList}
                design="2026"
                triggerClassName="justify-start gap-[8px] pl-[12px] md:pl-[20px] md:gap-[28px] [&>p]:text-[18px] [&>p]:md:text-[32px]"
                contentClassName="p-[20px_0] md:p-[40px_0] xl:p-[40px]"
                hideItemBorder
            />
        </>
    );
}
